import {
  action,
  computed,
  makeObservable, observable, runInAction,
} from 'mobx';
import { Matrix } from 'src/models/matrix/matirx';
import { OrganicWasteMaterials } from 'src/models/organic-waste-materials/organic-waste-materials';
import { ItemType } from '../../types';

export enum GeneratorType {
  Commercial = 1,
  Multifamily = 2,
  NonLocalEntity = 3,
  Other = 4,
  Residential = 5,
  ResidentialMultifamily = 6
}

export class ComplianceMatrixStore {
  @observable.ref complianceMatrix?: Matrix;
  @observable.ref organicWasteMaterials = new OrganicWasteMaterials();
  @observable generatorType?: ItemType | null;

  constructor() {
    makeObservable(this);
  }

  @computed get isResidentialGenerator() {
    if (!this.generatorType) return true;
    return this.generatorType?.id === GeneratorType.Residential
      || this.generatorType?.id === GeneratorType.ResidentialMultifamily;
  }

  @action setGeneratorType = (type?: ItemType | null) => {
    runInAction(() => {
      this.generatorType = type;
    })
  }

  @action fetchMatrix = (id: number) => {
    this.complianceMatrix = new Matrix(id);
  }

  @action loadMatrix = (id: number) => {
    if (!this.complianceMatrix) {
      this.fetchMatrix(id)
    }
  }

  @action fetchOrganicMaterials = async (id:number) => {
    await this.organicWasteMaterials.getOrganicMaterials(id)
  }

  @action loadOrganicMaterials = async (id: number) => {
    if (!this.organicWasteMaterials) {
      await this.fetchOrganicMaterials(id)
    }
  }
}
